import React from 'react';

import {
  StyledCheckbox,
} from '../../coreui';

export const TaxcenterCheckbox = React.forwardRef(({
  disabled,
  ...props
}, ref) => (
  <StyledCheckbox disabled={disabled} {...props} ref={ref} />
));

export const createTaxcenterCheckbox = (row) => {
  return (
    <TaxcenterCheckbox
      disabled={(row.original.status.value !== 'uploaded')}
      handleClick={row.value.handleClick}
      checked={row.value.selected}
      data-test={`tax-center-checkbox-${row.viewIndex}`}
    />
  );
};

export default {
  createTaxcenterCheckbox,
  TaxcenterCheckbox,
};
